import React from 'react';
import './pageLoadingAnimation.css';

type Props = {};

const PageLoadingAnimation = (props:Props) => {
    console.log(props);
    return (
        <div className="animationBody">
            <div className="animationContainer">
                <div className="box1" />
                <div className="box2" />
                <div className="box3" />
            </div>
        </div>

    );
};

export default PageLoadingAnimation;
